module.exports = __webpack_public_path__ + "img/alipay.fb888cfb.png";